module.exports = __webpack_public_path__ + "static/media/news.d6b8afd4.JPG";